import { createContext, useContext } from 'react'

export type FiltersSettings = {
  initialFilters: object
}

export const FiltersSettingsContext = createContext<FiltersSettings>({
  initialFilters: { sort: { sort_by: 'SUGGESTED', sort_type: 'ASC' } }
})

export function useFiltersSettings() {
  const context = useContext(FiltersSettingsContext)
  if (!context) {
    throw new Error(
      'useFiltersSettings must be used within a FiltersSettingsProvider'
    )
  }
  return context
}

export const FiltersSettingsProvider = ({
  children,
  ...rest
}: React.PropsWithChildren<FiltersSettings>) => (
  <FiltersSettingsContext.Provider value={rest}>
    {children}
  </FiltersSettingsContext.Provider>
)
